//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'about_us',
  data() {
    return {

    }
  },
  mounted(){

  },
  methods: {

  },
  components: {}
}



// WEBPACK FOOTER //
// ./src/components/about_us.vue